export default function initBlockFaq() {
    const faqItems = document.querySelectorAll('.block-faq__list');

    faqItems.forEach(item => {
        const question = item.querySelector('.block-faq__item-question');
        const answer = item.querySelector('.block-faq__item-answer');
        const icon = question.querySelector('.icon');

        question.addEventListener('click', function () {
            // Zamknij wszystkie inne odpowiedzi
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem
                        .querySelector('.block-faq__item-question')
                        .classList.remove('visible');
                    otherItem
                        .querySelector('.block-faq__item-answer')
                        .classList.remove('visible');
                    otherItem
                        .querySelector('.icon')
                        .classList.remove('rotated');
                }
            });

            // Przełącz bieżące pytanie
            this.classList.toggle('visible');
            const isOpen = answer.classList.toggle('visible');
            icon.classList.toggle('rotated', isOpen);
        });
    });
}

initBlockFaq();
